var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.957,
    height: 20,
    viewBox: "0 0 20.957 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_534",
    "data-name": "Union 534",
    d: "M14496.875-15190h-11.988a.89.89,0,0,1-.889-.889.89.89,0,0,1,.889-.889h2.229v-14.457a3.767,3.767,0,0,1,1.1-2.662,3.765,3.765,0,0,1,2.662-1.1h7.193a3.776,3.776,0,0,1,2.664,1.1,3.774,3.774,0,0,1,1.1,2.662v14.457h2.227a.889.889,0,0,1,.889.889.889.889,0,0,1-.889.889Zm3.188-1.777v-14.457a1.989,1.989,0,0,0-.584-1.4,1.986,1.986,0,0,0-1.4-.584h-7.193a1.989,1.989,0,0,0-1.4.584,1.989,1.989,0,0,0-.584,1.4v14.457h2.3v-4.386a2.319,2.319,0,0,1,.682-1.646,2.308,2.308,0,0,1,1.643-.682h1.918a2.27,2.27,0,0,1,.889.177,2.261,2.261,0,0,1,.758.5,2.329,2.329,0,0,1,.5.753,2.359,2.359,0,0,1,.178.893v4.386Zm-4.076,0v-4.386a.53.53,0,0,0-.041-.21.589.589,0,0,0-.119-.18.545.545,0,0,0-.18-.119.568.568,0,0,0-.211-.045h-1.916a.566.566,0,0,0-.391.164.557.557,0,0,0-.158.39v4.386Zm-4.387-8.772a.887.887,0,0,1-.889-.888.887.887,0,0,1,.889-.889h5.754a.888.888,0,0,1,.889.889.888.888,0,0,1-.889.888Zm0-3.836a.887.887,0,0,1-.889-.889.887.887,0,0,1,.889-.889h5.754a.888.888,0,0,1,.889.889.888.888,0,0,1-.889.889Z",
    transform: "translate(-14483.998 15210.001)",
    fill: "#474a4e",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLight);
export default __webpack_public_path__ + "static/media/CompanyLight.58921ec603e63d63368f2c2c71b97693.svg";
export { ForwardRef as ReactComponent };